module.exports = __webpack_public_path__ + "img/bf2596e.jpg";